export default {"src":"/_next/static/media/icCup.f2d54cda.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};